import script from "./TripFulfilmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TripFulfilmentPage.vue?vue&type=script&setup=true&lang=js"

import "./TripFulfilmentPage.vue?vue&type=style&index=0&id=32005998&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32005998"]])

export default __exports__